import styled from 'styled-components';

import {FONT_FAMILIES} from '../../const';
import useAuth from '../../hooks/providers/useAuth';
import usePwa from '../../hooks/providers/usePwa';
import LogoSvg from '../../img/company-logo';
import rightImagePartners from '../../img/macbook-pro-grey.png';
import rightImageDrivn from '../../img/macbook-pro.png';
import {isMobile} from '../../utils';

const ContainerLeft = styled.div`
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 50%;
  background-color: ${import.meta.env.VITE_MAIN_COLOR};
  position: relative;

  @media screen and (max-width: 1000px) {
    width: 100%;
  }
`;

const ContainerRight = styled.div`
  background-color: #ffffff;
  height: 100%;
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  box-sizing: border-box;

  @media screen and (max-width: 1000px) {
    display: none;
  }
`;

const ImageContainer = styled.div`
  margin-top: 1vw;
  width: ${props => (props.size === 'small' ? '35vw' : '45vw')};
  height: ${props => (props.size === 'small' ? '35vw' : '45vw')};
  border-radius: 50%;
  background-color: rgba(21, 56, 101, 0.1);
  display: flex;
  justify-content: flex-end;
  align-items: center;

  img {
    width: ${props => (props.size === 'small' ? '45vw' : '55vw')};
    padding-right: 1vw;
  }
`;

const LoginButton = styled.button`
  margin-top: 10vh;
  background-color: ${import.meta.env.VITE_SECONDARY_COLOR};
  padding: 16px 109px;
  border-radius: 4px;
  color: #f6f9ff;
  border: none;
  font-family: ${FONT_FAMILIES.BODY};
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;

  :hover {
    opacity: 0.7;
  }
`;

const FooterText = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 85px;
  display: flex;
  color: #f6f9ff;
  justify-content: center;
  align-items: center;
  border-top: 1px solid rgba(246, 249, 255, 0.1);

  a {
    font-weight: 600;
    text-decoration-line: underline;
    color: #f6f9ff;
    margin-left: 6px;

    :hover {
      opacity: 0.7;
    }
  }
`;

const LoginForm = () => {
  const imageSrc = import.meta.env.VITE_COMPANY_NAME === 'drivn' ? rightImageDrivn : rightImagePartners;
  const {webInstallPrompt} = usePwa();

  const auth = useAuth();

  const signin = async () => {
    await auth.login();
  };

  const isWebPwaPromptVisible = !navigator.standalone && webInstallPrompt && !isMobile();

  return (
    <>
      <ContainerLeft>
        <LogoSvg />
        <LoginButton type="button" onClick={signin}>
          J'accède à l'application
        </LoginButton>
        <FooterText>
          Besoin de plus d'information ? <a href={import.meta.env.VITE_ASK_ACCESS_URL}>Contactez-nous !</a>
        </FooterText>
      </ContainerLeft>
      <ContainerRight>
        <ImageContainer size={isWebPwaPromptVisible ? 'small' : 'large'}>
          <img data-testid="right-image" src={imageSrc} alt="" />
        </ImageContainer>
      </ContainerRight>
    </>
  );
};

LoginForm.propTypes = {};

export default LoginForm;
